import { z } from 'zod'

export const setPaymentCategoriesRequestSchema = z.object({
  dividendCategoryId: z.string().nullable().optional(),
  couponCategoryId: z.string().nullable().optional(),
  // per-account income-description templates with {ticker}/{name} placeholders; a blank/null
  // value falls back to the built-in "Дивиденды/Купоны {label}" default at promotion time.
  dividendDescriptionTemplate: z.string().nullable().optional(),
  couponDescriptionTemplate: z.string().nullable().optional(),
  // opt-in, confirmation-gated retroactive re-categorization: when true, every already-created
  // dividend/coupon income on this account is re-pointed to the new (effective) category, not just
  // future/held payouts. only honored when the matching category resolves to a non-null value.
  recategorizeExistingDividends: z.boolean().optional(),
  recategorizeExistingCoupons: z.boolean().optional(),
})

export type SetPaymentCategoriesRequestDto = z.infer<typeof setPaymentCategoriesRequestSchema>
